import constant from "@/constant";
const OrderCustomer = {
  code: {},
  order_no: {},
  order_date:{},
  status: {},
  note: {},
  location_arrival_id: {
    relationDefault: "location_arrival"
  },
  location_destination_id: {
    relationDefault: "location_destination",
  },
  ETD_date: { dataType: "date", defaultValue: "now" },
  ETD_time: {
    dataType: "time",
    defaultValue: "now",
  },
  ETA_date: { dataType: "date", defaultValue: "now", increment: 1 },
  ETA_time: {
    dataType: "time",
    defaultValue: "now",
  },
  
  listVehicleGroup: {
    dataType: "array",
  },
  list_files:{
    dataType:"array"
  },

  distance: 0,
  weight: 0,
  volume: 0,
};

const Goods = {
  code: {},
  title: {},
  file_id: {},
  path_of_file_id: {},
  goods_unit_id: {
    relation: "goods_unit",
  },
  in_amount: {
    dataType: "number",
  },
  out_amount: {
    dataType: "number",
  },
  weight: {
    dataType: "number",
  },
  volume: {
    dataType: "number",
  },
  note: {
    field: "note",
  },
};
const GoodsUnit = {
  code: {},
  title: {},
};
const Location = {
  code: {},
  title: {},
  address: {},
  province_id: {
    relation: "province",
  },
  district_id: {
    relation: "district",
  },
  ward_id: {
    relation: "ward",
  },

};


const DefaultData = {
  code: {},
  client_id: {
    relation: "client",
  },
  location_destination_id: {
    relation: "location_destination",
  },
  location_arrival_id: {
    relation: "location_arrival",
  },
};
const Contact ={
  contact_name:{},
  phone_number:{}
}

export default {
  OrderCustomer,
  Goods,
  GoodsUnit,
  Location,
  DefaultData,
  Contact
};
